import { TransactionReason, TransactionResultReason } from '../domain/stream/transaction/TransactionDomains';
import { CaseActionHistoryItem } from '../domain/case/CaseDomains';
import LanguageUtil from './LanguageUtil';

class CaseEventTextUtil {
  public static getStatusText(status: TransactionReason | TransactionResultReason | undefined): string {
    if (status == undefined) return 'Unknown';
    switch (status) {
      case TransactionResultReason.DECLINED:
        return 'Declined';
      case TransactionResultReason.APPROVED:
        return 'Approved';
      case TransactionResultReason.ESCALATED:
        return 'Escalated';
      case TransactionReason.IN_REVIEW:
        return 'In Review';
      case TransactionReason.FRAUD:
        return 'Marked as Fraud';
      case TransactionReason.IN_COMPLIANT:
        return 'Marked as Incompliant';
      case TransactionReason.NOT_FRAUD:
        return 'Marked as not Fraud';
      case TransactionReason.COMPLIANT:
        return 'Marked as Compliant';
      case TransactionReason.WAITING_FOR_REVIEW:
        return 'Waiting for Review';
      case TransactionReason.ON_HOLD:
        return 'On Hold';
      default:
        return status;
    }
  }

  public static isBulk(event: { type?: string; closeType?: string; bulk?: boolean }): boolean {
    return event.bulk === true || (event.type == 'CLOSE' && event.closeType == 'BULK');
  }

  public static getCloseTypeText(event: { closeType?: string; bulk?: boolean }): string {
    const closeType: string = event.bulk === true ? 'BULK' : (event.closeType ?? 'SINGLE').toUpperCase();
    switch (closeType) {
      case 'API':
        return 'API CLOSE';
      case 'BULK':
        return 'BULK CLOSE';
      case 'SINGLE':
        return 'CLOSE';
      default:
        return 'CLOSE';
    }
  }

  public static getTypeText(event: { type?: string; closeType?: string; bulk?: boolean }): string {
    if (event.type == 'CLOSE') {
      return CaseEventTextUtil.getCloseTypeText(event);
    }
    if (CaseEventTextUtil.isBulk(event)) {
      return `BULK_${event.type}`;
    }
    return event.type ?? '';
  }

  public static getRunActionText(action: string | undefined, success: boolean | undefined): string {
    return success === false
      ? LanguageUtil.get({ id: 'pages.case.event.runActionFailed', defaultMessage: 'Run Action: {0} (failed)' }, { 0: action ?? '' })
      : LanguageUtil.get({ id: 'pages.case.event.runAction', defaultMessage: 'Run Action: {0}' }, { 0: action ?? '' });
  }

  public static getListUpdateText(type: 'LIST_ADD' | 'LIST_REMOVE', list: string | undefined, value: string | undefined): string {
    return type == 'LIST_ADD'
      ? LanguageUtil.get({ id: 'pages.case.event.listAdd', defaultMessage: 'Added to list {0}: {1}' }, { 0: list ?? '', 1: value ?? '' })
      : LanguageUtil.get({ id: 'pages.case.event.listRemove', defaultMessage: 'Removed from list {0}: {1}' }, { 0: list ?? '', 1: value ?? '' });
  }

  public static getDetail(item: CaseActionHistoryItem): string {
    switch (item.type) {
      case 'ACTION':
        return CaseEventTextUtil.getRunActionText(item.action, item.success);
      case 'LIST_ADD':
      case 'LIST_REMOVE':
        return CaseEventTextUtil.getListUpdateText(item.type, item.list, item.value);
      default:
        return CaseEventTextUtil.getStatusText(item.status as TransactionReason);
    }
  }
}

export default CaseEventTextUtil;
